import cc from "classcat"

export const CardHover = ({
  children,
  className = "",
  shadow = "shadow-md  hover:shadow-xl",
}) => (
  <div
    className={cc([
      "transform  transition-all duration-300 hover:-translate-y-2",
      className,
      shadow,
    ])}
  >
    {children}
  </div>
)
